<template>
  <span
    class="avatar rounded-circle"
    :class="{
      disabled: disabled,
      'avatar-placeholder': isPlaceholder,
      'avatar-status': status,
      'active': active,
    }"
    :style="{width: `${size}px`, height: `${size}px`}"
  >
    <img
      v-if="!isPlaceholder"
      :src="source"
      :alt="user.name"
      :width="size"
      :height="size"
    >

    <span v-else-if="!!text">{{ text }}</span>

    <SvgIcon
      v-else
      name="components/user"
      :width="`${size * 0.40625}`"
      :height="`${size * 0.5}`"
    />
  </span>
</template>

<script>
import SvgIcon from 'vue-svgicon/dist/components/svgicon.common'

import '../../icons/components/user'

export default {
  components: {
    SvgIcon,
  },
  props: {
    /**
     * User Information
     */
    user: {
      type: Object,
      default: () => ({}),
    },

    /**
     * Set the size of the UserAvatar.
     */
    size: {
      type: [String, Number],
      default: 64,
    },

    /**
     * Avatar does not react on mouse events.
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * Avatar includes status indicator.
     */
    status: {
      type: Boolean,
      default: false,
    },

    /**
     * Set Avatar in active state.
     */
    active: {
      type: Boolean,
      default: false,
    },

    /**
     * Avatar text.
     */
    text: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    isPlaceholder () {
      const validAttributes = ['first_name', 'last_name', 'name', 'picture_url', 'avatar']
      const userAttributes = Object.keys(this.user || {})
      const includeValidAttributes = userAttributes.map((i) => validAttributes.includes(i)).filter(Boolean).length > 0

      return !!this.text || Object.keys(userAttributes).length === 0 || !includeValidAttributes
    },
    name () {
      return this.user.name ? this.user.name : `${this.user.first_name} ${this.user.last_name}`.trim()
    },
    source () {
      if (!this.isPlaceholder) {
        if (this.user.avatar) {
          return this.user.avatar
        } else {
          const background = this.getRandomBackgroundColor().replace('#', '')
          const initials = this.initials.join('')

          return `https://eu.ui-avatars.com/api/?background=${background}&color=fff&rounded=true&name=${initials}&bold=true&size=${this.size * 2}&font-size=0.33`
        }
      } else {
        return null
      }
    },
    initials () {
      let initials = []

      if (!this.user.last_name && !this.user.last_name && !!this.name) {
        initials = this.name.split(' ')
      } else {
        initials = [
          `${this.user.first_name ? this.user.first_name[0] : ''}`,
          `${this.user.last_name ? this.user.last_name[0] : ''}`,
        ]
      }

      return initials.filter(Boolean)
    },
  },

  methods: {
    getRandomBackgroundColor () {
      const colors = ['#C7115A', '#9F4576', '#006853', '#6C17A6', '#255FD1', '#00778F', '#D9461A', '#475E69']

      const seed = this.initials
          .map((c) => c.toLowerCase().charCodeAt(0) - 97)
          .reduce((a, b) => a + b, 0)

      return colors[seed % (colors.length)] || '#C7115A'
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar *:not(img) {
  font-size: 28%;
  color: $gray-800;
}
</style>
